import Api from 'utils/api'
import i18n from 'utils/i18n'

export const airportApiCredSlice = ((set, get) => ({
  touchpoints: [],
  locationId: null,

  actions: {
    fetchTouchpoints: async (params) => {
      get().actions.startLoading();
      const api = new Api();
      api.getTouchpoints(params)
        .then((response) => {
          set((state) => ({ touchpoints: response.data.touchpoints }));
          get().actions.stopLoading();
        })
      .catch((err) => {
        get().actions.stopLoading();
        get().actions.setSnackMessage({show: true, type: "error", text: i18n.t(err.response.data[0]?.message)})
      });
    },

    setLocationId: async (locationId) => {
      set((state) => ({ locationId: locationId }));
    }
  }

}))